module.exports = __webpack_public_path__ + "img/main.c71c6ae7.jpg";